import { createAction } from 'redux-actions'
import gql from 'graphql-tag'

import client from '../services/ApolloClient'

export const requestPublicationsFailAction = createAction('PUBLICATIONS_FAIL_FETCH')
export const requestPublicationsAction = createAction('PUBLICATIONS_REQUEST_FETCH')
export const requestPublicationsSuccessAction = createAction('PUBLICATIONS_SUCCESS_FETCH')

export const savePublicationFailAction = createAction('PUBLICATION_FAIL_SAVE')
export const savePublicationAction = createAction('PUBLICATION_REQUEST_SAVE')
export const savePublicationSuccessAction = createAction('PUBLICATION_SUCCESS_SAVE')

export const deletePublicationFailAction = createAction('PUBLICATION_FAIL_DELETE')
export const deletePublicationAction = createAction('PUBLICATION_REQUEST_DELETE')
export const deletePublicationSuccessAction = createAction('PUBLICATION_SUCCESS_DELETE')

const apiToClientFormatPublication = (apiPublication) => ({
  id: apiPublication.id,
  title: apiPublication.titulo,
  description: apiPublication.descricao,
  image: `data:image/jpeg;base64,${apiPublication.imagem}`,
  link: apiPublication.link,
  priority: apiPublication.prioridade
})

const clientToApiFormatPublication = (publication) => ({
  id: publication.id,
  titulo: publication.title,
  descricao: publication.description,
  imagem: publication.image.split(',')[1],
  link: publication.link,
  prioridade: publication.priority
})

export const fetchPublications = injection => {
  return dispatch => {
    dispatch(requestPublicationsAction())

    return client.query({
      fetchPolicy: 'no-cache',
      query: gql`
        query FetchNews {
          publications(limit: 999999, page: 1) {
            id
            titulo
            descricao
            imagem
            link
            prioridade
          }
        }
      `
    }).then(({ data }) => dispatch(
        requestPublicationsSuccessAction((data.publications || []).map(apiToClientFormatPublication))
      ))
      .catch(({ errors }) => dispatch(requestPublicationsFailAction(new Error(errors))))
  }
}

export const savePublication = (publication, injection) => {
  let input = clientToApiFormatPublication(publication)

  return (dispatch) => {
    dispatch(savePublicationAction())
    return client.mutate({
      fetchPolicy: 'no-cache',
      mutation: gql`
        mutation SavePublication($input: CreatePublicationInput!) {
          createPublication(input: $input) {
            id
            titulo
            descricao
            imagem
            link
            prioridade
          }
        }
      `,
      variables: { input }
    }).then(() => dispatch(savePublicationSuccessAction()))
      .catch(({ errors }) => dispatch(savePublicationFailAction(new Error(errors[0].message))))
  }
}

export const deletePublication = (id, injection) => {
  return (dispatch) => {
    dispatch(deletePublicationAction())

    return client.mutate({
      fetchPolicy: 'no-cache',
      mutation: gql`
        mutation DeletePublication($id: Int!) {
          deletePublication(id: $id) {
            ok
          }
        }
      `,
      variables: { id }
    }).then(() => dispatch(deletePublicationSuccessAction()))
      .catch(err => dispatch(deletePublicationFailAction(new Error(err))))
  }
}



// WEBPACK FOOTER //
// ./src/actions/publications.js